/* Loyalty Riverwood Block JS
   - Werkt samen met Loyalty Engage plugin API
   - Gebruikt server-side personalisatie via /api/products/:shop
   - Behoudt bestaande Riverwood markup/classes
*/
(function () {
  'use strict';

  if (window.__rwLoyaltyInit) return;
  window.__rwLoyaltyInit = true;

  var API = 'https://shpfy.loyaltyengage.tech';

  function text(value, fallback) {
    return value == null || value === '' ? (fallback || '') : String(value);
  }

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return Number.isNaN(n) ? (fallback || 0) : n;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function showToast(message, success) {
    var t = document.getElementById('rw-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'rw-toast';
      t.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);padding:12px 22px;border-radius:8px;font-family:inherit;font-size:14px;font-weight:700;z-index:99999;transition:opacity .3s;pointer-events:none;';
      document.body.appendChild(t);
    }
    t.textContent = message;
    t.style.background = success ? '#2d7a3a' : '#c0392b';
    t.style.color = '#fff';
    t.style.opacity = '1';
    clearTimeout(t._timer);
    t._timer = setTimeout(function () {
      t.style.opacity = '0';
    }, 3500);
  }

  function updateProgressBar(el, blockId, points) {
    var tierPointsRaw = (el.dataset.tierPoints || '')
      .split(',')
      .map(function (s) { return toInt(String(s).trim(), 0); });

    if (!tierPointsRaw.length) return;

    var currentTierIdx = 0;
    for (var i = 0; i < tierPointsRaw.length; i++) {
      if (points >= tierPointsRaw[i]) currentTierIdx = i;
    }

    var nextTierIdx = currentTierIdx + 1;
    var isMaxTier = nextTierIdx >= tierPointsRaw.length;

    var fillPct = 100;
    if (!isMaxTier) {
      var fromPts = tierPointsRaw[currentTierIdx];
      var toPts = tierPointsRaw[nextTierIdx];
      if (toPts > fromPts) {
        fillPct = Math.max(0, Math.min(100, Math.round(((points - fromPts) / (toPts - fromPts)) * 100)));
      }
    }

    var bubblePct = Math.max(5, Math.min(95, fillPct));

    var fillEl = document.getElementById('rw-prog-fill-' + blockId);
    var bubbleEl = document.getElementById('rw-prog-bubble-' + blockId);
    var tiersEl = document.getElementById('rw-prog-tiers-' + blockId);

    if (fillEl) fillEl.style.width = fillPct + '%';
    if (bubbleEl) bubbleEl.style.left = bubblePct + '%';

    if (tiersEl) {
      var spans = tiersEl.querySelectorAll('.rw-prog-tier');
      spans.forEach(function (span, idx) {
        if (points >= (tierPointsRaw[idx] || 0)) span.classList.add('done');
        else span.classList.remove('done');
      });
    }
  }

  function buildVariantSelector(variants) {
    var wrapper = document.createElement('div');
    wrapper.className = 'rw-variant-wrapper';

    var select = document.createElement('select');
    select.className = 'rw-variant-select';

    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = 'Kies een optie...';
    placeholder.disabled = true;
    placeholder.selected = true;
    select.appendChild(placeholder);

    variants.forEach(function (variant) {
      var opt = document.createElement('option');
      opt.value = variant.id || '';
      opt.textContent = text(variant.title, 'Variant') + (variant.available ? '' : ' (uitverkocht)');
      opt.disabled = !variant.available;
      select.appendChild(opt);
    });

    wrapper.appendChild(select);
    return wrapper;
  }

  async function getCartContext() {
    try {
      var res = await fetch('/cart.js');
      var data = await res.json();
      var cartSubtotal = (data.total_price || 0) / 100;
      var cartSkus = [];

      if (Array.isArray(data.items)) {
        data.items.forEach(function (item) {
          if (item && item.properties && item.properties._loyalty === 'true' && item.sku) {
            cartSkus.push(String(item.sku));
          }
        });
      }

      return {
        cartSubtotal: cartSubtotal,
        cartSkus: cartSkus
      };
    } catch (_) {
      return {
        cartSubtotal: 0,
        cartSkus: []
      };
    }
  }

  async function redeemPhysical(btn, card, el, shop, customerId) {
    var sku = btn.dataset.sku || '';
    var origText = btn.textContent.trim();
    var selector = card.querySelector('.rw-variant-select');
    var variantId = selector ? selector.value : (btn.dataset.variantId || '');

    if (!variantId) {
      showToast('Selecteer eerst een variant.', false);
      return;
    }

    btn.textContent = el.dataset.processingText || 'Verwerken...';
    btn.disabled = true;

    try {
      var cart = await getCartContext();

      var res = await fetch(
        API + '/api/physical-redeem/' + encodeURIComponent(sku) + '/' + encodeURIComponent(customerId) + '/' + encodeURIComponent(shop),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            variantId: variantId,
            cartSubtotal: cart.cartSubtotal,
            cartSkus: cart.cartSkus
          })
        }
      );

      var result = await res.json();

      if (!result.success || !result.discountCode) {
        showToast(result.message || el.dataset.addToCartError || 'Kon beloning niet inwisselen.', false);
        btn.disabled = false;
        btn.textContent = origText;
        return;
      }

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {
            _loyalty: 'true',
            _free: 'true'
          }
        })
      });

      var addResult = await addRes.json();

      if (!addResult.id) {
        showToast(addResult.description || el.dataset.addToCartError || 'Kon product niet toevoegen.', false);
        btn.disabled = false;
        btn.textContent = origText;
        return;
      }

      showToast(el.dataset.addedToCartText || 'Product toegevoegd! Je wordt doorgestuurd...', true);
      setTimeout(function () {
        window.location.href = '/checkout?discount=' + encodeURIComponent(result.discountCode);
      }, 1200);
    } catch (err) {
      console.error('[RiverwoodLoyalty] Physical redeem error:', err);
      showToast(el.dataset.errorText || 'Er ging iets mis. Probeer het opnieuw.', false);
      btn.disabled = false;
      btn.textContent = origText;
    }
  }

  async function redeemDiscount(btn, el, shop, customerRef, sku) {
    var origText = btn.textContent.trim();
    btn.textContent = el.dataset.processingText || 'Verwerken...';
    btn.disabled = true;

    try {
      var cart = await getCartContext();

      var res = await fetch(
        API + '/api/discount/' + encodeURIComponent(sku) + '/' + encodeURIComponent(customerRef) + '/' + encodeURIComponent(shop),
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            cartSubtotal: cart.cartSubtotal
          })
        }
      );

      var result = await res.json();

      if (!result.success || !result.discountCode) {
        showToast(result.message || 'Kon kortingscode niet aanmaken.', false);
        btn.disabled = false;
        btn.textContent = origText;
        return;
      }

      try {
        navigator.clipboard.writeText(result.discountCode);
      } catch (_) {}

      showToast('Code ' + result.discountCode + ' gekopieerd! Gebruik bij het afrekenen.', true);
      btn.textContent = '✓ ' + result.discountCode;
    } catch (err) {
      console.error('[RiverwoodLoyalty] Discount redeem error:', err);
      showToast(el.dataset.errorText || 'Er ging iets mis.', false);
      btn.disabled = false;
      btn.textContent = origText;
    }
  }

  function buildSnackCard(reward, el, shop, customerId, availableCoins, customerPoints) {
    var title = text(reward.shopify && reward.shopify.title, 'Product');
    var coins = toInt(reward.loyalty && reward.loyalty.coinPrice, 0);
    var reqPoints = toInt(reward.loyalty && reward.loyalty.requiredPoints, 0);
    var sku = text(reward.loyalty && reward.loyalty.sku, '');
    var img = text((reward.loyalty && reward.loyalty.imageUrl) || (reward.shopify && reward.shopify.image), '');
    var variants = (reward.shopify && reward.shopify.variants) || [];
    var hasMultiple = !!(reward.shopify && reward.shopify.hasMultipleVariants);
    var defaultVid = text((reward.shopify && reward.shopify.variantId) || '', '').split('/').pop();
    var canAfford = availableCoins >= coins;
    var accessible = !reqPoints || customerPoints >= reqPoints;

    var card = document.createElement('div');
    card.className = 'rw-snack' + (!accessible ? ' rw-snack--locked' : (!canAfford ? ' rw-snack--no-coins' : ''));

    var imgHtml = img
      ? '<div class="rw-snack-img-wrap"><img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" loading="lazy"><span class="rw-snack-pts-pill">' + coins + ' coins</span></div>'
      : '<div class="rw-snack-img-wrap rw-snack-img-wrap--empty"><span class="rw-snack-pts-pill">' + coins + ' coins</span></div>';

    card.innerHTML =
      imgHtml +
      '<div class="rw-snack-body">' +
        '<p class="rw-snack-name">' + escapeHtml(title) + '</p>' +
        '<div class="rw-snack-actions"></div>' +
      '</div>';

    var actionsEl = card.querySelector('.rw-snack-actions');

    if (!accessible) {
      actionsEl.innerHTML = '<p class="rw-snack-locked-msg">🔒 ' + escapeHtml(el.dataset.lockedLabel || 'Beschikbaar vanaf') + ' ' + reqPoints + ' punten</p>';
      return card;
    }

    if (hasMultiple && variants.length > 1) {
      actionsEl.appendChild(buildVariantSelector(variants));
    }

    var btn = document.createElement('button');
    btn.className = 'rw-snack-btn';
    btn.dataset.sku = sku;
    btn.dataset.variantId = defaultVid;

    if (!canAfford) {
      btn.disabled = true;
      btn.textContent = el.dataset.notEnoughCoins || 'Niet genoeg coins';
      btn.classList.add('rw-snack-btn--disabled');
    } else {
      btn.textContent = el.dataset.redeemBtnLabel || 'Inwisselen';
      btn.addEventListener('click', function () {
        redeemPhysical(btn, card, el, shop, customerId);
      });
    }

    actionsEl.appendChild(btn);
    return card;
  }

  function buildVoucherCard(reward, el, shop, customerRef, availableCoins, customerPoints, isPopular) {
    var title = text(reward.shopify && reward.shopify.title, 'Voucher');
    var coins = toInt(reward.loyalty && reward.loyalty.coinPrice, 0);
    var reqPoints = toInt(reward.loyalty && reward.loyalty.requiredPoints, 0);
    var sku = text(reward.loyalty && reward.loyalty.sku, '');
    var canAfford = availableCoins >= coins;
    var accessible = !reqPoints || customerPoints >= reqPoints;

    var card = document.createElement('div');
    card.className = 'rw-voucher' + (!accessible ? ' locked' : '');

    var popularHtml = isPopular ? '<div class="rw-voucher-popular">POPULAIR</div>' : '';
    var lockHtml = !accessible ? '<span class="rw-voucher-lock">🔒 ' + reqPoints + ' punten vereist</span>' : '';

    card.innerHTML =
      popularHtml +
      '<span class="rw-voucher-amount' + (!accessible ? ' muted' : '') + '">' + escapeHtml(title) + '</span>' +
      '<span class="rw-voucher-lbl">Korting</span>' +
      '<span class="rw-voucher-pts' + (!accessible ? ' muted' : '') + '">' + coins + ' coins</span>' +
      lockHtml;

    if (accessible && canAfford) {
      card.style.cursor = 'pointer';
      card.addEventListener('click', function () {
        redeemDiscount(card, el, shop, customerRef, sku);
      });
    }

    return card;
  }

  function sortByRequiredPoints(items) {
    return items.slice().sort(function (a, b) {
      return toInt(a.loyalty && a.loyalty.requiredPoints, 0) - toInt(b.loyalty && b.loyalty.requiredPoints, 0);
    });
  }

  function sortByCoinPrice(items) {
    return items.slice().sort(function (a, b) {
      return toInt(a.loyalty && a.loyalty.coinPrice, 0) - toInt(b.loyalty && b.loyalty.coinPrice, 0);
    });
  }

  document.querySelectorAll('[id^="rw-block-"]').forEach(function (el) {
    var blockId = el.dataset.blockId;
    var shop = window.Shopify && Shopify.shop;
    var customerId = el.dataset.customerId || null;
    var customerEmail = el.dataset.customerEmail || '';
    var customerRef = customerId || customerEmail || null;
    var availableCoins = toInt(el.dataset.coins, 0);
    var customerPoints = toInt(el.dataset.customerPoints, 0);

    updateProgressBar(el, blockId, customerPoints);

    if (!shop) return;
    if (!customerRef) return;

    async function loadProducts() {
      var snacksEl = document.getElementById('rw-snacks-' + blockId);
      var vouchersEl = document.getElementById('rw-vouchers-' + blockId);

      try {
        var url = new URL(API + '/api/products/' + encodeURIComponent(shop));
        if (customerId) {
          url.searchParams.set('customerId', String(customerId));
        } else if (customerEmail) {
          url.searchParams.set('customerEmail', customerEmail);
        }

        var res = await fetch(url.toString());
        if (!res.ok) throw new Error('API error ' + res.status);

        var data = await res.json();
        var allProducts = Array.isArray(data.matchedProducts) ? data.matchedProducts : [];

        var physicalProducts = sortByRequiredPoints(
          allProducts.filter(function (reward) {
            return reward.loyalty && reward.loyalty.product_type === 'physical';
          })
        );

        var discountProducts = sortByCoinPrice(
          allProducts.filter(function (reward) {
            return reward.loyalty && reward.loyalty.product_type === 'discount_code';
          })
        );

        if (snacksEl) {
          snacksEl.innerHTML = '';
          if (!physicalProducts.length) {
            snacksEl.innerHTML = '<p class="rw-empty">' + escapeHtml(el.dataset.noProductsText || 'Geen producten beschikbaar.') + '</p>';
          } else {
            physicalProducts.forEach(function (reward) {
              snacksEl.appendChild(
                buildSnackCard(reward, el, shop, customerId, availableCoins, customerPoints)
              );
            });
          }
        }

        if (vouchersEl) {
          vouchersEl.innerHTML = '';
          if (!discountProducts.length) {
            vouchersEl.innerHTML = '<p class="rw-empty">' + escapeHtml(el.dataset.noProductsText || 'Geen vouchers beschikbaar.') + '</p>';
          } else {
            discountProducts.forEach(function (reward, idx) {
              var isPopular = idx === 0 && availableCoins >= toInt(reward.loyalty && reward.loyalty.coinPrice, 0);
              vouchersEl.appendChild(
                buildVoucherCard(reward, el, shop, customerRef, availableCoins, customerPoints, isPopular)
              );
            });
          }
        }
      } catch (err) {
        console.error('[RiverwoodLoyalty] Load error:', err);
        if (snacksEl) {
          snacksEl.innerHTML = '<p class="rw-empty">' + escapeHtml(el.dataset.errorText || 'Kon producten niet laden.') + '</p>';
        }
        if (vouchersEl) {
          vouchersEl.innerHTML = '';
        }
      }
    }

    loadProducts();
  });
})();